/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-promise-reject-errors */

'use es6';

const fetchLoginVerifyFallback = apiClient => {
  return apiClient.get('login-verify/hub-user-info');
};
export default (({
  apiClient
}) => {
  return new Promise((resolve, reject) => {
    if (!window.quickFetch && !window.earlyRequester) {
      return fetchLoginVerifyFallback(apiClient).then(resolve, () => {
        reject('login-verify call failed.', 'Not setting up wootric-nps.');
      });
    }
    const earlyRequesterObj = window.quickFetch || window.earlyRequester;
    const earlyRequest = earlyRequesterObj.getRequestStateByName('api-verify');
    if (!earlyRequest) {
      return fetchLoginVerifyFallback(apiClient).then(resolve, () => {
        reject('login-verify call failed.', 'Not setting up wootric-nps.');
      });
    }
    let {
      result
    } = earlyRequest;
    const {
      errored,
      data,
      finished
    } = earlyRequest;

    // QuickFetch "lite" includes `data` key instead of `result`
    if (!result && data) {
      result = data;
    }
    if (!finished) {
      return reject('login-verify call hasn’t finished.', 'Please only set up wootric-nps when user data is avaiable.');
    }
    if (errored) {
      return reject('login-verify call failed.', 'Not setting up wootric-nps.');
    }
    return resolve(result);
  });
});